import axios from "axios";
import {API_FE_DOMAIN, API_FE_VALIDATE_AGENT_PROMOTION} from "../constants";
import {SET_PROMOCODE_VALIDATION_DATA} from "../reducers";
import { put, call } from 'redux-saga/effects';

export default function* validateAgentPromotionSaga(action) {
    try {
        const result = yield call(() => axios.post(
            API_FE_DOMAIN + API_FE_VALIDATE_AGENT_PROMOTION,
            action.payload,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }
        ));

        const response = result.data;

        if (response.status === 1) {
            yield put({
                type: SET_PROMOCODE_VALIDATION_DATA,
                payload: {
                    promocodeStatus: 'success',
                    promocode: action.payload.promotion,
                    fullPromocode: action.payload.fullCode,
                    migrationParam: action.payload.migrationParam,
                },
            });
        } else {
            const error = response.error;

            yield put({
                type: SET_PROMOCODE_VALIDATION_DATA,
                payload: {
                    promocodeStatus: 'error',
                    promocode: action.payload.promotion,
                    promocodeMessage: error.message,
                    code: error.code,
                },
            });
        }
    } catch (e) {
        console.log(e);
    }
}
